/** angular */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
/** end angular */

/** services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** end services */

/** models */
import { BydModel } from '@sixense/byd-core-service';
import { DsEmitterUserGroup } from '../models/ds-emitter-user-group.class';
import { AddRightToEmitter } from '../models/add-right-to-emitter.class';
/** end models */

/** interfaces */
import { DsEmitterUserGroupInterface } from '../interfaces/ds-emitter-user-group.interface';
/** end interfaces */

@Injectable({
  providedIn: 'root',
})
export class DsEmitterUserGroupsService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get emitters rights.
   *
   * @param projectId the project id
   * @returns Observable<BydModel<DsEmitterUserGroup>>
   */
  public getEmittersRights(projectId: number): Observable<BydModel<DsEmitterUserGroup>> {
    this.path = `/projects/${projectId}/emittersrights`;
    return this.getModels<DsEmitterUserGroup>();
  }

  /**
   * Add right to emitter.
   *
   * @param projectId the project id
   * @param emitterId the emitter id
   * @param groupId the group id
   * @param rightId the right id
   * @returns Observable<{ id: number }>
   */
  public addRightToEmitter(
    projectId: number,
    emitterId: number,
    groupId: number,
    rightId: number
  ): Observable<{
    /**
     *
     */
    id: number;
  }> {
    this.path = `/projects/${projectId}/emitters/${emitterId}/usergroups/${groupId}/emitterrights/${rightId}`;
    return this.post<{
      /**
       *
       */
      id: number;
    }>({ body: new AddRightToEmitter(emitterId, groupId, rightId) });
  }

  /**
   * Remove right from emitter.
   *
   * @param projectId the project id
   * @param emitterId the emitter id
   * @param groupId the group id
   * @param rightId the right id
   * @returns Observable<boolean>
   */
  public removeRightFromEmitter(
    projectId: number,
    emitterId: number,
    groupId: number,
    rightId: number
  ): Observable<boolean> {
    this.path = `/projects/${projectId}/emitters/${emitterId}/usergroups/${groupId}/emitterrights/${rightId}`;
    return this.delete<boolean>();
  }

  /**
   * Create DsEmitterUserGroup instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsEmitterUserGroup` instance.
   */
  public createNewInstance(jsonObject: DsEmitterUserGroupInterface): DsEmitterUserGroup {
    return new DsEmitterUserGroup(jsonObject);
  }
}
